"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageBannerText on EditorialBannerText {\n    text\n    textLinks {\n      title\n      relativeUrl\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageHeader on EditorialHeader {\n    __typename\n    authorName\n    id\n    publishedDate\n    isSharingEnabled\n    headline\n    extraLongHeadline\n    text\n    imageUrl\n    links {\n      data {\n        __typename\n      }\n    }\n    photographerName\n    headlineStorybookColor\n    backgroundStorybookColor\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageOlapic on EditorialOlapic {\n    __typename\n    id\n    categoryId\n    product {\n      productCode\n    }\n    type\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageProductBoxCarousel on EditorialProductBoxCarousel {\n    __typename\n    headline\n    products {\n      productCode\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageBannerModule on EditorialBannerModule {\n    backgroundColor {\n      type\n    }\n    backgroundStorybookColor\n    content {\n      title\n      titleColor\n      titleStorybookColor\n      titleSize\n      caption\n      showReadMoreOption\n      horizontalAlignment\n      textCollection {\n        ...EditorialPageBannerText\n      }\n    }\n    backgroundType\n    backgroundVideo {\n      autoplayOnScroll\n      id\n      playInLoop\n      type\n    }\n    link {\n      relativeUrl\n      title\n      data {\n        __typename\n        ... on Product {\n          productCode\n          labels {\n            labelKey\n            productLabelDomain\n            title\n          }\n          concept {\n            name\n            products {\n              productCode\n            }\n          }\n          price {\n            price {\n              currentPrice\n            }\n          }\n        }\n      }\n    }\n    backgroundImage {\n      url\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialPageBanner on EditorialBanner {\n    __typename\n    id\n    layout\n    modules {\n      ...EditorialPageBannerModule\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialContent on EditorialPageContent {\n    ... on EditorialHeader {\n      ...EditorialPageHeader\n    }\n    ... on EditorialOlapic {\n      ...EditorialPageOlapic\n    }\n    ... on EditorialProductBoxCarousel {\n      ...EditorialPageProductBoxCarousel\n    }\n    ... on EditorialBanner {\n      ...EditorialPageBanner\n    }\n    ... on EditorialPage {\n      ...EditorialPage\n    }\n    ... on EditorialTestimonialCarousel {\n      ...TestimonialModule\n    }\n    ... on EditorialFrequentlyAskedQuestions {\n      ...FaqModule\n    }\n    ... on EditorialFiftyBanner {\n      ...FiftyBanner\n    }\n    ... on EditorialLinkList {\n      ...LinkList\n    }\n    ... on EditorialBenefits {\n      ...Benefits\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialArticlePage on Application {\n    editorialPage(channelType: Web, pageId: $pageId) {\n      pageId\n      contentItems {\n        ...EditorialContent\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorialPageProductBoxCarouselFragment = exports.editorialPageOlapicFragment = exports.editorialPageHeaderFragment = exports.editorialPageBannerTextFragment = exports.editorialPageBannerModuleFragment = exports.editorialPageBannerFragment = exports.editorialContentTypesFragment = exports.editorialArticlePageFragment = void 0;
var _fetching = require("@ori/fetching");
var _benefitsFragment = require("./benefitsFragment");
var _faqModuleFragment = require("./faqModuleFragment");
var _fiftyModuleFragment = require("./fiftyModuleFragment");
var _linkListFragment = require("./linkListFragment");
var _testimonialModuleFragment = require("./testimonialModuleFragment");
const editorialPageBannerTextFragment = exports.editorialPageBannerTextFragment = (0, _fetching.gql)(_templateObject());
const editorialPageHeaderFragment = exports.editorialPageHeaderFragment = (0, _fetching.gql)(_templateObject1());
const editorialPageOlapicFragment = exports.editorialPageOlapicFragment = (0, _fetching.gql)(_templateObject2());
const editorialPageProductBoxCarouselFragment = exports.editorialPageProductBoxCarouselFragment = (0, _fetching.gql)(_templateObject3());
const editorialPageBannerModuleFragment = exports.editorialPageBannerModuleFragment = (0, _fetching.gql)(_templateObject4());
const editorialPageBannerFragment = exports.editorialPageBannerFragment = (0, _fetching.gql)(_templateObject5(), editorialPageBannerModuleFragment, editorialPageBannerTextFragment);
const editorialContentTypesFragment = exports.editorialContentTypesFragment = (0, _fetching.gql)(_templateObject6(), editorialPageHeaderFragment, editorialPageOlapicFragment, editorialPageProductBoxCarouselFragment, editorialPageBannerFragment, _testimonialModuleFragment.testimonialModuleFragment, _faqModuleFragment.faqModuleFragment, _fiftyModuleFragment.fiftyModuleFragment, _linkListFragment.linkListFragment, _benefitsFragment.benefitsFragment);
const editorialArticlePageFragment = exports.editorialArticlePageFragment = (0, _fetching.gql)(_templateObject7(), editorialContentTypesFragment);
